<div class="map-container h-full" [class.showing-popup]="showingPopup$ | async">
  <div
    #map
    id="map"
    class="h-full min-h-[28rem] w-full rounded-2xl border-0 md:min-h-[30rem] lg:min-h-[34rem]"
  ></div>
</div>
